import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-registers-main',
  templateUrl: './registers-main.component.html',
  styleUrls: ['./registers-main.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegistersMainComponent {
  selectedIndex: number = 0;
  isInternationalTabActivated = false;

  onChangeTabIndex(event: number): void {
    if (event) {
      this.isInternationalTabActivated = true;
    }
  }
}
